import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';


import { SnotifyService } from 'ng-snotify';
import { SharedDataService } from '../../service/shared-data.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import Editor from "../../../assets/js/ckeditor";
import { CKEditorComponent, ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { GoogleAnalyticsService } from '../../service/google-analytics.service';
import { StaticDataService } from '../../service/static-data.service';

@Component({
  selector: 'new-metadata',
  templateUrl: './new-metadata.component.html',
  styleUrls: ['./new-metadata.component.css']
})
export class NewMetadataComponent implements OnInit,OnChanges {
  newMeta: any;
  toggleResult: any;
  textResult: any;
  toggleToField: boolean;
  textResultForm: FormControl;
  @ViewChild('textAreaEl',{static: false}) textAreaElement: ElementRef;
  storyEditMode = false;
  text = "";
  ckconfig = {
    toolbar: ['bold', 'italic','bulletedList','numberedList','alignment','link'],
    disableTwoWayDataBinding: false
  };
  public ckEditor = Editor;
  infoFocusFlag: boolean;
  descriptionFocusFlag: boolean;
  descriptionEditor: any;
  infoEditor: any;
  @ViewChild('editorDynamicField',{static:false})
  editorDynamicField: CKEditorComponent;
  constructor( private sharedService: SharedDataService, private snotify: SnotifyService,    private gaService:GoogleAnalyticsService,
    ) { }

  @Input()
  set editable(editable: boolean) {
    this.storyEditMode = editable ? editable : false;
  }
  @Input()
  set addedMeta(addedMeta: any) {
    this.newMeta = addedMeta ? addedMeta : {};
  }
  // @Input()
  // set checkedField(checkedField: any) {
  //   this.toggleResult = checkedField ? checkedField : {'key': '', 'value': ''};
  // }
  @Input() checkedField: any;
  @Input() disabledToggle:boolean;

  @Output() emitToggleValue: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    this.textResult = this.toggleResult;
    if (this.newMeta.fieldType === 'toggle') {
      if (this.toggleResult.value === 'true') {
        this.textResult.value = true;
      } else {
        this.textResult.value = false;
      };
    } else if (this.newMeta.fieldType === 'text') {
        this.textResultForm = new FormControl(this.textResult.value);
        this.textResultForm.valueChanges
        .pipe(debounceTime(300)
        ,distinctUntilChanged())
        .subscribe(result => {
          this.metaTextData(result);
        });
        if (this.newMeta.toggleToField === 'false' || !this.newMeta.toggleToField) {
          this.toggleToField = true;
        } else if (this.toggleResult.value) {
          this.toggleToField = true;
        } else {
          this.toggleToField = false;
        }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
        this.toggleResult = this.checkedField ? this.checkedField : {'key': '', 'value': ''};
  }

  @HostListener('keydown', ['$event'])
  public hotkeys($event) {
    const key = $event.keyCode || $event.charCode;
    if(this.textAreaElement) {
      const a = this.textAreaElement.nativeElement.getElementsByClassName('ck-off');
      if (key === 72 && $event.ctrlKey && $event.shiftKey
        || $event.metaKey && key === 72 && $event.shiftKey) {
        console.log('hyperlink');
        $event.preventDefault();
        if (a.length > 0) {
          a[0].click();
        }
        $event.stopPropagation();
      }
    }
  }

  toggleSwitch(toggleValue) {
    if(this.textResult.key === 'noFollowNoIndex') {
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('Are you sure you want to continue?', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.textResult.value = !toggleValue;
              this.emitToggleValue.emit(this.textResult);
              this.snotify.remove(toast.id);
              this.googleAnalytics("Skippable Alerts",'Are you sure you want to continue?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);
            }, bold: false
          },
          {
            text: 'No', action: (toast) => {
              this.textResult.value = toggleValue;
              this.snotify.remove(toast.id);
              this.googleAnalytics("Skippable Alerts",'Are you sure you want to continue?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
            }
          }
        ]
      });

    } else {
      this.textResult.value = !toggleValue;
      this.emitToggleValue.emit(this.textResult);
    }

  }
  googleAnalytics(eventCategory,eventAction,eventLabel,eventValue){
    this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
   }
  metaTextData(data) {
      this.emitToggleValue.emit(this.textResult);
  }

  initializeEditor(model) {
    setTimeout(() => {
    if(this.editorDynamicField && model==='desc') {
      this.editorDynamicField.editorInstance.setData(this.textResult.value)
    }
   }, 200);
  }

  ckchanges(ev, label, model) {
    if(label === 'ready' && this.textResult.value!=='') {
      this.initializeEditor(model)
    }
    if (label === 'change') {
      this.emitToggleValue.emit(this.textResult)
    }
  }
  
  htmlToPlainTextExcludingPara(text) {
    if (typeof text === 'string') {
      return this.htmlSpecialCharToText(text);
    } else {
      return text;
    }
  }
  htmlSpecialCharToText(text) {
    const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
      'nbsp': ' ',
      'amp': '&',
      'quot': '\'',
      'lt': '<',
      'gt': '>'
    };
    return (text.replace(translate_re,
      (match, entity) => {
        return translate[entity];
      })
    );
  }

  toggleToFieldChange() {
    this.toggleToField = !this.toggleToField;
    if (!this.toggleToField) {
      this.textResult.value = '';
      this.emitToggleValue.emit(this.textResult);
    }
  }

}
